import type {
	AnnouncementSettingsResponse,
	CompanyThemingSettingsData,
	RovoExtAdminSettings,
} from './types';

/**
 * Projections between the consolidated `rovoextadminsettings` bucket and the
 * per-feature shapes that theming and announcement consumers expect.
 *
 * These live outside `gatewayClient` so that the shared admin-settings query can
 * derive every feature view from a single cached payload without importing the
 * request layer.
 */

const adminSettingToThemingColor = (value: string | undefined): string | null =>
	value ? value : null;

export const getCompanyThemingSettingsFromAdminSettings = (
	adminSettings: RovoExtAdminSettings,
): CompanyThemingSettingsData => ({
	fontColorLight: adminSettingToThemingColor(adminSettings.companyThemingFontColorLight),
	fontColorDark: adminSettingToThemingColor(adminSettings.companyThemingFontColorDark),
	navbarColorLight: adminSettingToThemingColor(adminSettings.companyThemingNavbarColorLight),
	navbarColorDark: adminSettingToThemingColor(adminSettings.companyThemingNavbarColorDark),
});

export const getCompanyThemingAdminSettingsPayload = (
	data: CompanyThemingSettingsData,
): Partial<RovoExtAdminSettings> => ({
	companyThemingFontColorLight: data.fontColorLight ?? '',
	companyThemingFontColorDark: data.fontColorDark ?? '',
	companyThemingNavbarColorLight: data.navbarColorLight ?? '',
	companyThemingNavbarColorDark: data.navbarColorDark ?? '',
});

export const getAnnouncementsFromAdminSettings = (
	adminSettings: RovoExtAdminSettings,
): AnnouncementSettingsResponse => adminSettings.companyAnnouncements ?? [];
